// ***** Dependencies *****
import { useCallback } from "react";

// ***** Interfaces, Types and imports *****
import { playSound, stopSound, SoundKind } from "@controllers/sound-controller";

/**
 * Thin wrapper over the shared sound controller. The audio elements live in the
 * controller, so mounting this hook allocates nothing and fetches nothing.
 */
export const NotificationSound = () => {
    const toggle = useCallback((type: SoundKind, state: boolean) => {
        if (state) {
            playSound(type);
        } else {
            stopSound(type);
        }
    }, []);

    return { toggle };
};

export default NotificationSound;
